






import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SvgIcon extends Vue {
    /**
     *
     */
    @Prop({ required: true })
    public readonly glyph!: string;
    /**
     *
     */
    @Prop({ default: 20 })
    public readonly width!: number | string;
    /**
     *
     */
    @Prop({ default: 20 })
    public readonly height!: number | string;
    /**
     *
     */
    public beforeMount() {
        const sprite = document.getElementById('icons-sprite');

        if (!sprite) {
            return console.warn(`[${this.$options.name}]: cannot find icons sprite`);
        }

        const symbol = (sprite as any).getElementById(this.$props.glyph);

        if (!symbol) {
            console.warn(
                `[${this.$options.name}]: symbol "${this.$props.glyph}" not found`
            );
        }
    }
}
